import { render, staticRenderFns } from "./SupplierContactPurchases.vue?vue&type=template&id=f0b75a2a"
import script from "./SupplierContactPurchases.vue?vue&type=script&lang=js"
export * from "./SupplierContactPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports